export default __webpack_public_path__ + "static/media/Group 3039.5596c56a.png";